import React from 'react';
import ProductContainerPreview from './ProductContainerPreview';
import ProductLabelPreview from './ProductLabelPreview';
import type { ProductLabelDesign, ProductWorkspaceDetail } from '../productLabelTypes';
import type { ProductContainerDesign } from '../productContainerTypes';

type Props = {
  product: ProductWorkspaceDetail;
  container: ProductContainerDesign;
  design: ProductLabelDesign;
  netQuantityLabel?: string | null;
  formatPrice: (n: number) => string;
  currency: string;
  className?: string;
};

export default function ProductStorefrontCardPreview({
  product,
  container,
  design,
  netQuantityLabel,
  formatPrice,
  currency,
  className = '',
}: Props) {
  const sale = Number(product.salePrice ?? product.pricePerUnit ?? 0);
  const unit = (product.unitLabel || product.baseUnit).toLowerCase();
  const stock = Number(product.currentStockLbs ?? 0);

  return (
    <article
      className={`mx-auto w-full max-w-[220px] overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm ${className}`}
    >
      <div className="relative flex h-40 items-center justify-center bg-slate-50 p-2">
        <ProductContainerPreview
          container={container}
          productImageUrl={product.imageUrl}
          compact
        >
          <ProductLabelPreview
            product={product}
            design={design}
            netQuantityLabel={netQuantityLabel}
            formatPrice={formatPrice}
            currency={currency}
            printId="storefront-card-label-print"
          />
        </ProductContainerPreview>
        <span className="absolute left-2 top-2 rounded-full bg-slate-900/80 px-2 py-0.5 text-[9px] font-semibold text-white">
          {stock > 0 ? `${stock.toFixed(1)} lb` : 'Pre-order'}
        </span>
      </div>
      <div className="border-t border-slate-100 p-3">
        <p className="line-clamp-2 text-sm font-semibold leading-snug text-slate-900">{product.name}</p>
        <p className="mt-1 text-sm font-bold text-emerald-700">
          {sale > 0 ? (
            <>
              {currency} {formatPrice(sale)}
              <span className="ml-1 text-xs font-normal text-slate-500">/ {unit}</span>
            </>
          ) : (
            <span className="text-slate-400">—</span>
          )}
        </p>
      </div>
      <div className="px-3 pb-3">
        <div className="flex items-center justify-between rounded-md border border-slate-200 bg-slate-50 text-slate-500">
          <span className="flex h-9 w-9 items-center justify-center text-lg">−</span>
          <span className="text-sm font-medium">0</span>
          <span className="flex h-9 w-9 items-center justify-center text-lg">+</span>
        </div>
        <p className="mt-2 text-center text-[10px] text-slate-500">
          Storefront card preview · how shoppers see this pack
        </p>
      </div>
    </article>
  );
}
